<template>
  <v-container fluid>
    <h2
      class="text-h6 my-4"
    >
      Conselheiros
    </h2>

    <v-row>
      <v-col
        v-for="conselheiro in conselheiros"
        :key="conselheiro.codigo"
        cols="12"
        sm="12"
        md="6"
        lg="4"
      >
        <v-card outlined>
          <v-simple-table>
            <tbody>
              <tr>
                <td style="width: 10%">
                  <b>Nome</b>
                </td>
                <td>{{ conselheiro.nome }}</td>
              </tr>
              <tr>
                <td style="width: 10%">
                  <b>Gestão Início</b>
                </td>
                <td>{{ conselheiro.gestaoInicio }}</td>
              </tr>
              <tr>
                <td style="width: 10%">
                  <b>Gestão Fim</b>
                </td>
                <td>{{ conselheiro.gestaoFim }}</td>
              </tr>
              <tr>
                <td style="width: 10%">
                  <b>Decreto</b>
                </td>
                <td>{{ conselheiro.decreto }}</td>
              </tr>
              <tr>
                <td style="width: 10%">
                  <b>Cargo</b>
                </td>
                <td>{{ conselheiro.cargo }}</td>
              </tr>
              <tr>
                <td style="width: 10%">
                  <b>Representação</b>
                </td>
                <td>{{ conselheiro.representacao }}</td>
              </tr>
              <tr>
                <td style="width: 10%">
                  <b>Vínculo</b>
                </td>
                <td>{{ conselheiro.vinculo }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import api from '@/api/vue-exemplo'

export default {
  name: 'Conselheiro',
  props: ['codigo'],
  data: () => ({
    conselheiros: []
  }),
  watch: {
    codigo () {
      this.getConselheiros()
    }
  },
  mounted () {
    //this.getGestores()
  },
  methods: {
    getConselheiros () {
      api.getConselheiros({
        codibge: this.codigo//this.$route.params.codigo
      })
        .then(response => {
          this.conselheiros = response.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>